/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface SaveUserNotes$Request {
    userId: number;
    body?: string;
}

export interface SaveUserNotes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserNotesRequest = createAction<PayloadData<void, SaveUserNotes$Request>>('SAVE_USER_NOTES__SAVE_USER_NOTES__REQUEST');
export const saveUserNotesSuccess = createAction<PayloadData<void, SaveUserNotes$Request>>('SAVE_USER_NOTES__SAVE_USER_NOTES__SUCCESS');
export const saveUserNotesFailure = createAction<PayloadData<Error, SaveUserNotes$Request, true>>('SAVE_USER_NOTES__SAVE_USER_NOTES__FAILURE');

export const saveUserNotesActions = [
    saveUserNotesRequest,
    saveUserNotesSuccess,
    saveUserNotesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {string} [meta.body]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserNotes = (meta: SaveUserNotes$Request, config?: SaveUserNotes$Config) => {
    return {
        CALL_API: {
            types: saveUserNotesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/notes`,
            TRANSPORT_REQUEST_BODY: meta.body,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

